import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { axiosInstance } from "../axiosConfig";
import {
  BackgroundLayout,
  DatePickerField,
  ItemText,
  OutlinedButton,
  FilledButton,
  PageLayout,
  RowEndLayout,
  RowStartLayout,
  TextField,
  TitleText,
  VerticalGap,
} from "../component";

const AddProjectScreen = () => {
  const navigator = useNavigate();

  const [projectName, setProjectName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [jobCode, setJobCode] = useState("");
  const [startDate, setStartDate] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!projectName || !fieldName || !jobCode || !startDate) {
      alert("모든 항목을 입력해주세요.");
      return;
    }
    if (window.confirm("프로젝트를 등록하시겠습니까?")) {
      try {
        await axiosInstance.post(
          `${process.env.REACT_APP_BASE_URL}/project/add`,
          {
            projectName,
            fieldName,
            jobCode,
            startDate: startDate + "T00:00:00",
          },
          {
            headers: {
              Authorization: `${localStorage.getItem("accessToken")}`,
            },
          }
        );
        alert("등록이 완료되었습니다.");
        navigator("/main");
      } catch (error) {
        console.error("프로젝트 등록 오류:", error);
        alert("프로젝트 등록에 실패했습니다.");
      }
    }
  };

  return (
    <PageLayout>
      <ProjectForm>
        <TitleText>새 프로젝트 등록</TitleText>
        <BackgroundLayout
          style={{
            justifyContent: "flex-start",
            flexDirection: "column",
            marginTop: "20px",
          }}
        >
          <VerticalGap height="20px" />
          <RowStartLayout>
            <ItemText>프로젝트 이름</ItemText>
            <TextField
              type="text"
              placeholder="프로젝트 이름을 입력하세요"
              value={projectName}
              onChange={(e) => {
                setProjectName(e.target.value);
              }}
            />
          </RowStartLayout>
          <RowStartLayout>
            <ItemText>현장 이름</ItemText>
            <TextField
              type="text"
              placeholder="현장 이름을 입력하세요"
              value={fieldName}
              onChange={(e) => {
                setFieldName(e.target.value);
              }}
            />
          </RowStartLayout>
          <RowStartLayout>
            <ItemText>Job code</ItemText>
            <TextField
              type="text"
              placeholder="Job code를 입력하세요"
              value={jobCode}
              onChange={(e) => {
                setJobCode(e.target.value);
              }}
            />
          </RowStartLayout>
          <RowStartLayout>
            <ItemText>공사 시작일</ItemText>
            <DatePickerField
              type="date"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />
          </RowStartLayout>
          <VerticalGap height="50px" />
        </BackgroundLayout>
        <VerticalGap height="20px" />
        <RowEndLayout>
          <FilledButton type="submit" onClick={handleSubmit}>
            등록
          </FilledButton>
          <OutlinedButton
            onClick={(e) => {
              e.preventDefault();
              navigator("/main");
            }}
          >
            취소
          </OutlinedButton>
        </RowEndLayout>
      </ProjectForm>
    </PageLayout>
  );
};

const ProjectForm = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export default AddProjectScreen;
